import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-1a5fc240"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  key: 0,
  class: "info-order-list"
};
var _hoisted_2 = {
  key: 0
};
var _hoisted_3 = {
  key: 1
};
var _hoisted_4 = /*#__PURE__*/_createTextVNode(" 选手限");
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "hl"
  }, "1", -1);
});
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("li", null, [/*#__PURE__*/_createTextVNode(" 请务必使用"), /*#__PURE__*/_createElementVNode("span", {
    class: "hl"
  }, "最新版本（至少80.0以上）的Chrome"), /*#__PURE__*/_createTextVNode("浏览器访问； ")], -1);
});
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("li", null, " 电脑建议操作系统：windows系统，win7及win7以上，8G以上内存，CPU建议酷睿i5以上，C盘（或系统盘）有4G以上剩余硬盘空间； ", -1);
});
var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("li", null, [/*#__PURE__*/_createTextVNode(" 电脑应配有"), /*#__PURE__*/_createElementVNode("span", {
    class: "hl"
  }, "摄像头、音箱或耳机、麦克风"), /*#__PURE__*/_createTextVNode("，建议使用含摄像头的笔记本电脑+耳麦； ")], -1);
});
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("li", null, " 登录后，请按系统提示，熟悉系统操作；检查网络环境、浏览器是否正常； ", -1);
});
var _hoisted_10 = {
  key: 2
};
var _hoisted_11 = {
  key: 3
};
var _hoisted_12 = {
  key: 4
};
var _hoisted_13 = {
  key: 5
};
var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("li", null, " 如果答题过程中因电源、网络故障等造成中断，请尽快再次登录，原有答题都会保存在系统中； ", -1);
});
var _hoisted_15 = {
  key: 6
};
var _hoisted_16 = {
  key: 7
};
var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("li", null, " 如不遵守考场纪律，不服从工作人员管理，有违纪、作弊等行为的，将按照 无成绩记录。 ", -1);
});
var _hoisted_18 = {
  key: 1,
  class: "info-order-list"
};
var _hoisted_19 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("li", null, " 据主题要求，选手在竞赛平台完成编程作品创作（创作作品可多次修改并保存作品，参赛选手只能提交1次，提交后不可修改，作品以比赛截止时间内提交为准，如学生没有提交，将按照截止时间内最后一次登录保存的内容进行自动提交参加评选。） ", -1);
});
var _hoisted_20 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("li", null, [/*#__PURE__*/_createTextVNode(" 请务必使用"), /*#__PURE__*/_createElementVNode("span", {
    class: "hl"
  }, "最新版本（至少80.0以上）的Chrome"), /*#__PURE__*/_createTextVNode("浏览器访问； ")], -1);
});
var _hoisted_21 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("li", null, " 电脑建议操作系统：windows系统，win7及win7以上，8G以上内存，CPU建议酷睿i5以上，C盘（或系统盘）有4G以上剩余硬盘空间； ", -1);
});
var _hoisted_22 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("li", null, [/*#__PURE__*/_createTextVNode(" 电脑应配有"), /*#__PURE__*/_createElementVNode("span", {
    class: "hl"
  }, "摄像头、音箱或耳机、麦克风"), /*#__PURE__*/_createTextVNode("，建议使用含摄像头的笔记本电脑+耳麦； ")], -1);
});
var _hoisted_23 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("li", null, "本次竞赛为公益活动，不收取参赛费用，学生自愿参与。", -1);
});
var _hoisted_24 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("li", null, " 每位选手严禁重复、虚假报名，一经发现或举报，经核实后将取消比赛资格。 ", -1);
});
var _hoisted_25 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("li", null, "提交作品不得是参加过其他比赛的作品。", -1);
});
var _hoisted_26 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("li", null, " 参赛作品须为原创，作品内容健康向上，不触犯国家法律法规，不得剽窃、抄袭、顶替他人作品，如因此引起任何法律纠纷，其法律责任由参赛选手本人承担，并取消选手的参赛资格和获奖资格。 ", -1);
});
var _hoisted_27 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("li", null, " 所有作品一经参赛，即视为参赛选手同意组委会拥有对其作品的使用权，同意组委会以任何形式对参赛作品进行展示和传播。 ", -1);
});
var _hoisted_28 = [_hoisted_19, _hoisted_20, _hoisted_21, _hoisted_22, _hoisted_23, _hoisted_24, _hoisted_25, _hoisted_26, _hoisted_27];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_a_spin = _resolveComponent("a-spin");
  var _component_a_modal = _resolveComponent("a-modal");
  return _openBlock(), _createBlock(_component_a_modal, {
    width: "800px",
    visible: _ctx.data.visible,
    "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.data.visible = $event;
    }),
    title: _ctx.isNocFlag ? '比赛须知' : '活动须知',
    "cancel-text": "暂不答题",
    "ok-text": _ctx.OkText,
    "mask-closable": false,
    onOk: _ctx.onStartExamButtonClick
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_a_spin, {
        size: "large",
        tip: "正在加载数据中...",
        spinning: _ctx.loading,
        delay: 200
      }, {
        default: _withCtx(function () {
          return [!_ctx.hideGetCertification ? (_openBlock(), _createElementBlock("ol", _hoisted_1, [_ctx.isNocFlag ? (_openBlock(), _createElementBlock("li", _hoisted_2, "比赛包含" + _toDisplayString(_ctx.data.baseInfoText) + "；", 1)) : (_openBlock(), _createElementBlock("li", _hoisted_3, "活动包含" + _toDisplayString(_ctx.data.baseInfoText) + "；", 1)), _createElementVNode("li", null, [_hoisted_4, _hoisted_5, _createTextVNode("次答题机会，" + _toDisplayString(_ctx.data.answerRule) + "超时自动提交； ", 1)]), _hoisted_6, _hoisted_7, _hoisted_8, _hoisted_9, _ctx.isNocFlag ? (_openBlock(), _createElementBlock("li", _hoisted_10, " 正式比赛之前请关闭QQ、微信等即时通信软件，比赛中不要跳出比赛网页； ")) : (_openBlock(), _createElementBlock("li", _hoisted_11, " 正式考试之前请关闭QQ、微信等即时通信软件，考试中不要跳出考试网页； ")), _ctx.isNocFlag ? (_openBlock(), _createElementBlock("li", _hoisted_12, " 请在规定时间作答完全部题目，比赛时间结束时，无论是否答完系统都将自动交卷； ")) : (_openBlock(), _createElementBlock("li", _hoisted_13, " 请在规定时间作答完全部题目，考试时间结束时，无论是否答完系统都将自动交卷； ")), _hoisted_14, _ctx.isNocFlag ? (_openBlock(), _createElementBlock("li", _hoisted_15, " 诚信比赛，自觉服从监考员等工作人员管理，不得以任何理由妨碍监考员等比赛工作人员履行职责，不得扰乱比赛工作的秩序； ")) : (_openBlock(), _createElementBlock("li", _hoisted_16, " 诚信考试，自觉服从监考员等工作人员管理，不得以任何理由妨碍监考员等考试工作人员履行职责，不得扰乱考试工作的秩序； ")), _hoisted_17])) : (_openBlock(), _createElementBlock("ol", _hoisted_18, _hoisted_28))];
        }),
        _: 1
      }, 8, ["spinning"])];
    }),
    _: 1
  }, 8, ["visible", "title", "ok-text", "onOk"]);
}